import React, {useImperativeHandle, useRef, useState} from 'react';
import TakeSelectPhoto, {
  TakeSelectPhotoProps,
  TakeSelectPhotoRefAttr,
} from '../../../components/TakeSelectPhoto';
import {ocrYDBase64} from '../../../API/ocr';
import {OCRRes} from '../../ocrResult/ocrSuccess';
import {useNavigation} from '@react-navigation/native';
import {Overlay} from '@rneui/themed';
import {Image, TouchableOpacity, View} from 'react-native';
import {createStyles} from '../../../utils/createStyles';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../../components/Loading/GlobalLoading';
import Toast from 'react-native-toast-message';

type Props = {
  onOCRSuccess?: (oCRRes: OCRRes) => void;
};

export type YouDaoOCRViewRef = {
  start: () => void;
};

const YouDaoOCRView = React.forwardRef<YouDaoOCRViewRef, Props>(
  (props: Props, ref: React.ForwardedRef<YouDaoOCRViewRef>) => {
    const navigation = useNavigation();
    const modalRef = useRef<NoOCRResRef>(null);
    const takeRef = useRef<TakeSelectPhotoRefAttr>(null);
    useImperativeHandle(ref, () => ({
      start: () => {
        takeRef.current?.open();
      },
    }));
    const onTakeFinish: TakeSelectPhotoProps['onTakeFinish'] = (
      action,
      img,
    ) => {
      console.log('onTakeFinish');
      if (img) {
        showGlobalLoading({text: '识别中...'});
        ocrYDBase64(img.data).then(res => {
          const ordData: OCRRes = res.data;
          hideGlobalLoading();
          if (res.status !== 200) {
            Toast.show({
              type: 'error',
              text1: '识别失败',
              text2: '请重试',
            });
          } else {
            if (props.onOCRSuccess) {
              props.onOCRSuccess(ordData);
            }
            if (ordData.errorCode === '12006') {
              if (ordData.editData) {
                navigation.navigate('OCREdit', {
                  editData: ordData.editData,
                });
              } else {
                modalRef.current?.toggleVisible(1);
              }
            } else if (ordData.recordId) {
              // @ts-ignore
              navigation.navigate('OCRSuccess', {
                recordId: ordData.recordId,
              });
            }
          }
        });
      }
    };
    return (
      <>
        <TakeSelectPhoto onTakeFinish={onTakeFinish} ref={takeRef} />
        <NoOCRResModal onClick={() => takeRef.current?.open()} ref={modalRef} />
      </>
    );
  },
);

export type NoOCRResProps = {
  onClick?: () => void;
};
export type NoOCRResRef = {
  toggleVisible: (style?: number) => void;
};

export const NoOCRResModal = React.forwardRef<NoOCRResRef, NoOCRResProps>(
  (props: NoOCRResProps, ref: React.ForwardedRef<NoOCRResRef>) => {
    const [isVisible, setIsVisible] = useState(false);
    const [modalStyle, setModalStyle] = useState<number>(2);
    const toggleVisible = (style?: number) => {
      if (style) {
        setModalStyle(style);
      }
      setIsVisible(v => !v);
    };
    const onPress = () => {
      toggleVisible();
      if (props.onClick) {
        props.onClick();
      }
    };
    useImperativeHandle(ref, () => ({
      toggleVisible,
    }));
    return (
      <Overlay
        isVisible={isVisible}
        overlayStyle={styles.overlayStyle}
        onBackdropPress={toggleVisible}>
        <View style={styles.noResWrap}>
          {modalStyle === 1 ? (
            <>
              <Image
                style={styles.noResImg}
                source={require('../../../assets/images/ocr/noRes.png')}
              />
              <TouchableOpacity
                style={styles.closeArea}
                onPress={() => toggleVisible()}
              />
              <TouchableOpacity style={styles.clickArea} onPress={onPress} />
            </>
          ) : (
            <>
              <Image
                style={styles.ocrEditImg}
                source={require('../../../assets/images/ocr/ocrEdit.png')}
              />
              <TouchableOpacity
                style={styles.closeArea}
                onPress={() => toggleVisible()}
              />
              <TouchableOpacity
                style={styles.clickArea2}
                onPress={() => toggleVisible()}
              />
            </>
          )}
        </View>
      </Overlay>
    );
  },
);

const styles = createStyles({
  overlayStyle: {
    backgroundColor: 'transparent',
    elevation: 0,
    shadowColor: 'transparent',
  },
  noResWrap: {
    position: 'relative',
  },
  closeArea: {
    position: 'absolute',
    top: '16%',
    left: '83%',
    right: '1%',
    bottom: '70%',
  },
  clickArea: {
    position: 'absolute',
    top: '70%',
    left: '18%',
    right: '18%',
    bottom: '5%',
  },
  noResImg: {
    width: '26.7rem',
    height: undefined,
    aspectRatio: 1250 / 992,
  },
  ocrEditImg: {
    width: '26.7rem',
    height: undefined,
    aspectRatio: 1068 / 1264,
  },
  clickArea2: {
    position: 'absolute',
    top: '77%',
    left: '18%',
    right: '18%',
    bottom: '5%',
  },
});
export default YouDaoOCRView;
